module.exports = __webpack_public_path__ + "img/val-icon-4.6e6ea71f.svg";